module.exports = __webpack_public_path__ + "012b71a1080be592eef80d3b8d4fea6b.svg";